import {
  PatchedRegistrationCategoryWriteRequest,
  RegistrationCategory,
  RegistrationCategoryBulkWriteRequest,
} from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useRegistrationCategoryBulkMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: { id: number; payload: RegistrationCategoryBulkWriteRequest[] }) => {
      const { data } = await SSF.api.competitionsSetRegistrationCategoriesCreate(id, payload);
      return data;
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}

export function usePartialUpdateRegistrationCategoryMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: { id: number; payload: PatchedRegistrationCategoryWriteRequest }) => {
      const { data } = await SSF.api.registrationCategoriesPartialUpdate(id, payload);
      return data;
    },
    onSuccess: ({ id, competition, limit, start_date, end_date }) => {
      /**
       * We're doing this to avoid uneccesary loading states & re-renders of heavy API calls
       */
      client.setQueryData<RegistrationCategory[]>(keys.list(competition.id), data => {
        return data?.map(rc => {
          return rc.id === id
            ? {
                ...rc,
                start_date,
                end_date,
                limit,
              }
            : rc;
        });
      });

      client.invalidateQueries({ queryKey: keys.detail(id) });
    },
  });
}
